@for (group of groups; track group.id) {
  <div class="mb-3">
    <h3>{{ group.name }}</h3>
    <sb-comp-rendered-templates [screen]="screen" [group]="group">

    </sb-comp-rendered-templates>
  </div>
} @empty {
  <div class="tw-p-4">
    <h4> {{ 'lang.globals.noData' | translate }}</h4>
  </div>
}
